import { useMutation, useQueryClient } from '@tanstack/react-query';

import updateTicket from './useUpdateTicket.request';
import { UpdateTicketPayload } from './useUpdateTicket.interface';

import { ApiResponse } from 'modules/IMC/MessageCenter/components/MessageCenterContent/MessageList/MessageList.interface';

export default function useUpdateTicket() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ ticketId, payload }: { ticketId: number; payload: UpdateTicketPayload }) =>
            updateTicket(ticketId, payload),

        onSuccess: ({ ticket: updatedTicket }) => {
            // optimistcally updates the cache of messageCenterTickets keys if it finds the ticket
            const queryCache = queryClient.getQueryCache();
            const queries = queryCache.findAll({ queryKey: ['messageCenterTickets'] });

            queries.forEach((query) => {
                const data = query.state.data as ApiResponse | undefined;
                if (data?.results) {
                    const updatedResults = data.results.map((ticket) =>
                        ticket.id === updatedTicket.id ? { ...ticket, ...updatedTicket } : ticket
                    );
                    queryClient.setQueryData(query.queryKey, { ...data, results: updatedResults });
                }
            });

            queryClient.invalidateQueries({
                queryKey: ['zdTicket', updatedTicket.id],
            });

            return updatedTicket;
        },
    });
}
